// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-final-doc-modal',
    templateUrl: './final-doc-modal.component.html',
    styleUrls: ['./finalize-doc-modal-component.scss'],
})
export class FinalDocModalComponent {
    constructor(
        private dialogRef: MatDialogRef<FinalDocModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { dealerPending: number; buyerPending: number; cobuyerPending: number; documentName: string }
    ) {}

    ok() {
        this.dialogRef.close();
    }

    numberOfDocsPending(): number {
        return this.data.dealerPending + this.data.buyerPending + this.data.cobuyerPending;
    }

    getDealerPendingDocsNumber(): number {
        return this.data.dealerPending;
    }

    getBuyerPendingDocsNumber(): number {
        return this.data.buyerPending;
    }

    getCoBuyerPendingDocsNumber(): number {
        return this.data.cobuyerPending;
    }
}
